import { Button } from '~/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip';
import { GroupLabel } from '~/features/toolbar/parts';
import { useStore } from '~/store';
import { guidelineCenter } from './guidelines';
import type { GuidelineAxis } from './slice';

export function GuidelinesToolbarGroup() {
  const hasSource = useStore((s) => s.source.dimensions !== null);

  const add = (axis: GuidelineAxis) => () => {
    const c = guidelineCenter(axis);
    if (c == null) return;
    useStore.getState().addGuideline(axis, c);
  };

  return (
    <div className="flex items-center gap-1.5 rounded-md border px-1 py-0.5">
      <GroupLabel>Guides</GroupLabel>
      <div className="flex gap-0.5">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              size="xs"
              variant="outline"
              onClick={add('v')}
              disabled={!hasSource}
              className="h-7 font-mono"
            >
              + V
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            Add vertical guideline <span className="ml-1 text-muted-foreground">(⇧V)</span>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              size="xs"
              variant="outline"
              onClick={add('h')}
              disabled={!hasSource}
              className="h-7 font-mono"
            >
              + H
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            Add horizontal guideline <span className="ml-1 text-muted-foreground">(⇧H)</span>
          </TooltipContent>
        </Tooltip>
      </div>
    </div>
  );
}
